import { BaseAnnotationControl } from "@/viewer/BaseAnnotationControl";
import Draw, { createRegularPolygon } from "ol/interaction/Draw";
import Style from "ol/style/Style";
import RegularShape from "ol/style/RegularShape";
import Fill from "ol/style/Fill";
import { Stroke } from "ol/style";
import Circle from "ol/style/Circle";
import { asArray } from "ol/color";
import { getStyle } from "@/viewer/helper";

export const type = Symbol("type");
export const strokeColor = Symbol("strokeColor");
export const fillColor = Symbol("fillColor");
export const drawInteraction = Symbol("drawInteraction");
export const annotationClass = Symbol("annotationClass");

export default class DrawAnnotationControl extends BaseAnnotationControl {
  callbackDrawingEnd = undefined;

  constructor({
    optType = "Point",
    optStrokeColor = "#001dff",
    optFillColor = "#fff",
    optSource = {},
    optElement = {},
    optTarget = {},
    optCallback = {},
    optAnnotationClass = {}
  } = {}) {
    super({
      type: optType,
      source: optSource,
      element: optElement,
      target: optTarget
    });

    this.callbackDrawingEnd = optCallback;
    this[annotationClass] = optAnnotationClass;
    this[strokeColor] = optStrokeColor;
    this[fillColor] = optFillColor;

    let geometryFunction;
    if (optType === "Circle") {
      geometryFunction = createRegularPolygon(64);
    }

    // square is a circle with 4 points
    if (optType === "Square") {
      geometryFunction = createRegularPolygon(4);
      optType = "Circle";
    }

    this[type] = optType;
    let pointerStyle = new Style({
      image: new RegularShape({
        fill: new Fill({
          color: "black"
        }),
        points: 4,
        radius1: 5,
        radius2: 1
      })
    });
    super.interaction = new Draw({
      type: this[type],
      // features: options.features,
      source: optSource,
      geometryFunction,
      style: pointerStyle,
      // add properties to type
      freehand: false
      // comment: "",
      // name: annoName
    });
  }

  activate() {
    super.interaction.on("drawstart", this.startDrawing.bind(this));
    super.interaction.on("drawend", this.endDrawing.bind(this));
    super.activate();
    // set cursor
    this.map.getViewport().style.cursor = "crosshair";
  }

  endDrawing(event) {
    super.map.getViewport().style.cursor = "crosshair";
    // add the annotation to the database
    // this.deactivate();

    if (this.callbackDrawingEnd !== undefined) {
      this.callbackDrawingEnd({
        ...event,
        annotationClass: this[annotationClass]
      });
    }
  }

  startDrawing(event) {
    super.map.getViewport().style.cursor = "crosshair";
    event.feature.setStyle(this.style);

    // Add unique timestamp as id
    // const date_today = new Date();
    // var datemilli = date_today.valueOf().toString();
    // event.feature.setId(datemilli);
    // event.feature.name = "asd";
    // event.feature.comment = "";
  }

  deactivate() {
    super.map.removeInteraction(this[drawInteraction]);
    super.deactivate();
  }

  get style() {
    return getStyle(this[type], this[fillColor], this[strokeColor]);
  }
}
